export default __webpack_public_path__ + "static/image-2021-12-21-10-15-21-920-7ca130e02ea16f9e88982a462aa3a8e4.png";